import {shallowEqual, useSelector} from "react-redux"
import { useLocation, useParams } from 'react-router-dom'

const EMPTY_OBJECT = {}

const selectConfig = (state, pathname, checkoutType) => {
  const storeData = state?.store?.storeDetails ?? EMPTY_OBJECT
  const {
    checkoutPaymentMethod,
    checkoutStoreType: deliveryType,
    cartAmountDetails,
    cateringAndMealkitCartAmountDetails,
  } = state?.checkout ?? EMPTY_OBJECT
  const storeDetails = state?.store?.storeDetails
  const age_restricted_notes = state?.checkout?.cartAmountDetails?.age_restricted_notes

  const cateringAndMealKitProductCartList = state?.cartWishlist?.cateringAndMealKitProductCartList
  const { is_mealkit = "0" } = cateringAndMealKitProductCartList?.[0] ?? EMPTY_OBJECT

  const isCateringMeal = checkoutType === "catering-meal"
  const isEcom = !isCateringMeal
  const isMealkit = isCateringMeal && is_mealkit === "1"
  const isCatering = isCateringMeal && is_mealkit === "2"

  const isPickup = deliveryType === "store_pickup"
  const isDelivery = deliveryType === "delivery"

  const allowBillingAddress = checkoutPaymentMethod === "cc"

  const getCustomerDetailsOnCheckoutForCateringMealKitOrder = +storeData?.allow_catering_and_mealkit_order_on_behalf_of_guest === 1

  const autoSaveCard = +storeDetails?.allow_ecom_authorize_and_captured_or_validate_and_sale === 0 ||
                      (+storeDetails?.allow_ecom_authorize_and_captured_or_validate_and_sale === 1 &&
                       +storeDetails?.allow_ecom_greater_than_authorization_captured_amount === 1 )

  const onEcomCheckoutPage = pathname === "/checkout"
  let showPrintedReceiptWithOrderOption = +storeDetails?.include_printed_receipt_with_order === 1
  let printedReceiptWithOrderMessage = storeDetails?.IncludePrintedReceiptWithOrderMessage ?? "Include Printed Receipt With Order"
  if (!onEcomCheckoutPage) {
    showPrintedReceiptWithOrderOption = false
  }

  const ageRestrictionRequired = Boolean(age_restricted_notes) && onEcomCheckoutPage

  let is_curbside_pickup = cartAmountDetails?.is_curbside_pickup
  let defaultCurbsideChecked = storeDetails?.allow_default_curbside_pickup === "1"
  let curbSideRequired = storeDetails?.allow_curbside_pickup_required_or_optional
  if (isCateringMeal) {
    is_curbside_pickup = cateringAndMealkitCartAmountDetails?.is_curbside_pickup
    defaultCurbsideChecked = storeDetails?.allow_default_curbside_pickup_catering_mealkit === "1"
    curbSideRequired = storeDetails?.allow_curbside_pickup_required_or_optional_catering_mealkit
  }

  const showCurbsidePickup = Boolean(is_curbside_pickup === "1" && isPickup)
  curbSideRequired = Boolean(showCurbsidePickup && curbSideRequired === "1")

  let showDoorDash = false
  if (isDelivery) {
    if (isEcom) {
      showDoorDash = storeDetails?.third_party_delivery_option === "door_dash"
    } else {
      showDoorDash = isCatering ? storeDetails?.third_party_catering_delivery_option === "door_dash" : storeDetails?.third_party_mealkit_delivery_option === "door_dash"
    }
  }

  let doorDashLable = ""
  if (isEcom) {
    doorDashLable = storeDetails?.third_party_delivery_option_lable
  } else {
    doorDashLable = isCatering ? storeDetails?.third_party_catering_delivery_option_lable : storeDetails?.third_party_mealkit_delivery_option_lable
  }

  if (doorDashLable) {
    doorDashLable = ` (${doorDashLable})`
  }

  return {
    getCustomerDetailsOnCheckoutForCateringMealKitOrder,
    allowBillingAddress,

    autoSaveCard,

    showPrintedReceiptWithOrderOption,
    printedReceiptWithOrderMessage,

    age_restricted_notes,
    ageRestrictionRequired,

    showCurbsidePickup,
    curbSideRequired,
    defaultCurbsideChecked,

    showDoorDash,
    onEcomCheckoutPage,
    doorDashLable,

    isEcom,
    isCateringMeal,
    isCatering,
    isMealkit,

    isPickup,
    isDelivery
  }
}

export const useConfig = () => {
  const { checkoutType } = useParams()
  const { pathname } = useLocation()
  return useSelector((state) => selectConfig(state, pathname, checkoutType), shallowEqual)
}

const selectConfigHeader = (state) => {
  const hs = state?.common?.commonDetailsData?.header_section ?? EMPTY_OBJECT
  return {
    allowCoupons: hs?.allow_coupons === "1",
    allowGrocery: +hs?.allow_ecom_cart_and_checkout === 1,
    allowCatering: +hs?.allow_catering_web === 1 || +hs?.mealkit_web === 1,
    showEcomMyOrderMenu: hs?.is_show_ecom_myorder_menu === "1",
    allowFuelCard: +hs?.AllowAdditionalCards === 1,
    fuelCardMinLength: +(hs?.AdditionalCardMinLength ?? 10),
    fuelCardMaxLength: +(hs?.AdditionalCardMaxLength ?? 12),
    mobileNumberRequiredForSignup: +hs?.isRequiredMobileNumberForRegisterUser === 1,
    allowReOrderEcomOrder: +hs?.allow_reorder_ecom_order === 1,
    allowReOrderCateringAndMealkitOrder: +hs?.allow_reorder_catering_and_mealkit_order === 1,
  }
}

export const useConfigHeader = () =>
  useSelector(selectConfigHeader, shallowEqual)

